<template>
  <VPagination
    :total="total"
    :items-per-page="pagination.per_page"
    :offset="offset"
    :hide-page-shifters="hidePageShifters"
    @on-go-to-page="emitOnGoToPage"
  >
    <template v-if="$slots.total" #total="slotProps">
      <slot name="total" v-bind="slotProps" />
    </template>
  </VPagination>
</template>

<script setup lang="ts">
  // Components
  import VPagination from '~/misc/v-pagination/index';

  // Types
  import type { TPagination, TSimplePagination } from '~/misc/resource/types';
  import type { PropType } from 'vue';
  import type { IPaginationEvent } from '~/misc/v-pagination/types';

  const props = defineProps({
    pagination: {
      type: Object as PropType<TPagination | TSimplePagination>,
      required: true,
    },
    total: {
      type: Number,
      default: 0,
    },
    hidePageShifters: {
      type: Boolean,
      default: undefined,
    },
  });

  const offset: ComputedRef<number> = computed(() => props.pagination.from - 1);

  const total: ComputedRef<number> = computed(() =>
    'total' in props.pagination ? props.pagination.total : props.total
  );

  const emit = defineEmits<{
    (e: 'on-go-to-page', page: number): void;
  }>();

  const emitOnGoToPage = (event: IPaginationEvent) => {
    emit('on-go-to-page', event.offset / event.limit + 1);
  };
</script>
